import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Modal from "react-modal";
import {
  convertStraight,
  convertTimeHHMMSS,
  convertTo24HourFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  fetchTrainerAssignedMembersData,
  fetchTrainerNotAssignedMembersData,
} from "../../../redux/reducers/apiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MemberCheckinLogs from "../../pt-trials/common/MemberCheckinLogs";

const AssignedNotAssignedTab = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();
  const {
    trainerAssignedMembers,
    trainerNotAssignedMembers,
    trainerAssignedMembersLoading,
    trainerNotAssignedMembersLoading,
  } = useSelector((state) => state.api);
  const [selectedTab, setSelectedTab] = useState(0);
  const [isPage, setIsPage] = useState(0);
  const initialFilters = { selectedOtherUsers: "", selectedShift: "" };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    trainer_id: allFilters.selectedOtherUsers?.value
      ? allFilters.selectedOtherUsers.value
      : "assigned",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allAssignedMembers: [],
    paginationAssigned: [],

    allNotAssignedMembers: [],
    paginationNotAssigned: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);
  const initialClickValues = {
    userId: "",
    isModOpen: false,
    type: "",
    sendableStatsQPs: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);

  const handleTabChange = (index) => {
    setSelectedTab(index);
    setIsPage(0);
  };

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  const onCloseModal = (name) => {
    setClickValues(initialClickValues);
  };

  function getAssignedMembers() {
    const updatedFilters = {
      ...prevFilters,
      ...filters,
    };

    dispatch(
      fetchTrainerAssignedMembersData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  function getNotAssignedMembers() {
    const { trainer_id, gym_id, ...rest } = filters;
    const updatedFilters = {
      ...prevFilters,
      trainer_id: "unassigned",
      gym_id: gym_id || allFilters?.selectedOtherUsers.info?.gym_id || "",
      ...rest,
    };

    dispatch(
      fetchTrainerNotAssignedMembersData({
        filters: updatedFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    if (allFilters.selectedShift && allFilters.selectedShift?.label) {
      const [start, end] = allFilters.selectedShift.label.split("TO");

      const formattedStartTime = start
        ? convertTo24HourFormat(start.trim())
        : "";

      const formattedEndTime = end ? convertTo24HourFormat(end.trim()) : "";

      setFilters({
        ...filters,
        shift_start_time: formattedStartTime,
        shift_end_date: formattedEndTime,
        page: isPage + 1,
        trainer_id: allFilters.selectedOtherUsers?.value
          ? allFilters.selectedOtherUsers.value
          : "assigned",
      });
    } else {
      setFilters((prevs) => ({
        ...prevs,
        page: isPage + 1,
        trainer_id: allFilters.selectedOtherUsers?.value
          ? allFilters.selectedOtherUsers.value
          : "assigned",
      }));
    }
  }, [allFilters, isPage]);

  useEffect(() => {
    if (selectedTab === 0) {
      getAssignedMembers();
    } else if (selectedTab === 1) {
      getNotAssignedMembers();
    }
  }, [prevFilters, filters, selectedTab]);

  useEffect(() => {
    if (trainerAssignedMembers?.status && trainerAssignedMembers?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allAssignedMembers: trainerAssignedMembers.data,
        paginationAssigned: trainerAssignedMembers?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allAssignedMembers: [],
        paginationAssigned: [],
      }));
    }
  }, [trainerAssignedMembers]);

  useEffect(() => {
    if (trainerNotAssignedMembers?.status && trainerNotAssignedMembers?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allNotAssignedMembers: trainerNotAssignedMembers.data,
        paginationNotAssigned: trainerNotAssignedMembers?.pagination || [],
      }));
    } else {
      setTbDatas((prevs) => ({
        ...prevs,
        allNotAssignedMembers: [],
        paginationNotAssigned: [],
      }));
    }
  }, [trainerNotAssignedMembers]);

  const tbColumns = [
    {
      dataField: "user_name",
      text: "Member",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}

            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    selectedTab !== 1 && {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.trainer_name || "NA"}

            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.trainer_mobile || ""}
              <br />
              {row?.trainer_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_start_date",
      text: "Subscription",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth250">
            <b>
              {row?.subscription_start_date
                ? formatDateTimezon(row?.subscription_start_date)
                : "-"}
            </b>{" "}
            TO{" "}
            <b>
              {row?.subscription_expire_date
                ? formatDateTimezon(row?.subscription_expire_date)
                : "-"}
            </b>
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data minWidth150 link"
            onClick={() => {
              setClickValues((prevs) => ({
                ...prevs,
                userId: row?.user_id,
                isModOpen: true,
                type: "member",
                cardType: "last-checkin",
                sendableStatsQPs: `&start_date=${
                  row?.last_checkin || ""
                }&end_date=${row?.last_checkin || ""}`,
              }));
            }}
          >
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}
            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </small>
          </span>
        );
      },
    },
  ];

  const tbColumnsUnassigned = [
    {
      dataField: "gym_name",
      text: "Gym",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "user_name",
      text: "Member",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.user_name || "NA"}

            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_start_date",
      text: "Subscription",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth250">
            <b>
              {row?.subscription_start_date
                ? formatDateTimezon(row?.subscription_start_date)
                : "-"}
            </b>{" "}
            TO{" "}
            <b>
              {row?.subscription_expire_date
                ? formatDateTimezon(row?.subscription_expire_date)
                : "-"}
            </b>
          </span>
        );
      },
    },
    {
      dataField: "last_checkin",
      text: "Member Last Checkin",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.last_checkin ? convertStraight(row.last_checkin) : "-"}

            <br />
            <small>
              {row?.checkin_time ? convertTimeHHMMSS(row.checkin_time) : ""}
              <br />
              {row?.last_checkin_days_ago
                ? row.last_checkin_days_ago?.replace(/_/g, " ")
                : ""}
            </small>
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Checkin Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer minWidth80vw">
          <ModalHeadAndClose
            title={`${clickValues.type} Checkin Logs`}
            onClose={onCloseModal}
          />

          <MemberCheckinLogs
            clickValues={clickValues}
            sendableStatsQPs={clickValues.sendableStatsQPs}
          />
        </div>
      </Modal>

      <div className="tab-view-table-container mt30">
        <Tabs onSelect={handleTabChange}>
          <TabList>
            <Tab>Assgined Members With Trainer</Tab>
            <Tab>Not Assigned Members</Tab>
          </TabList>

          <CommonFilterStructure
            from={"trainer-checkedin-notcheckedin"}
            decryptedText={userInfoData}
            setFilters={setAllFilters}
            filters={allFilters}
            onClickReset={onClickReset}
            isTrainers={true}
            prevGymId={prevFilters?.gym_id || ""}
            isShiftDropdown={allFilters.selectedOtherUsers?.value}
            trainerIdToGetShifts={allFilters.selectedOtherUsers?.value}
            isDisabledGym={
              selectedTab === 1 && allFilters.selectedOtherUsers?.info
                ? {
                    label: allFilters?.selectedOtherUsers.info?.gym_name || "",
                    value: allFilters?.selectedOtherUsers.info?.gym_id || "",
                  }
                : null
            }
            otherUserLabel={"Trainer"}
          />

          <TabPanel>
            <>
              <div className="overflowAuto separatedTable  mt30">
                {trainerAssignedMembersLoading ? (
                  <ReactVortoxSpinner />
                ) : (
                  <PaymentLinkTable
                    tableData={tbDatas.allAssignedMembers}
                    tableColumns={tbColumns}
                    tablePagination={tbDatas.paginationAssigned}
                    isPage={isPage}
                    setIsPage={(value) => setIsPage(value)}
                  />
                )}
              </div>
            </>
          </TabPanel>
          <TabPanel>
            <div className="overflowAuto separatedTable  mt30">
              {trainerNotAssignedMembersLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={tbDatas.allNotAssignedMembers}
                  tableColumns={tbColumns}
                  tablePagination={tbDatas.paginationNotAssigned}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                />
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </>
  );
};

export default AssignedNotAssignedTab;
